import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCustomQuestionFieldDelete(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionFieldDelete"],
    async (customQuestionFieldId: number) =>
      apiContext.customWorkflowQuestionApis.deleteCustomQuestionField(customQuestionFieldId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
